import React from 'react';
import { Box, Typography, InputBase } from '@mui/material';
import { useFormPalette } from '../pages/forms/DynamicFormPrimitives';
import { NODE_UI } from '../NodeUI/nodeUiStyles';

/**
 * Short label shown in the respondent-side stepper for this step. Distinct from the step's
 * {@code title} (which is the in-form heading). Empty = fall back to componentData.title.
 */
export default function StepperTitleInput({ value, onChange }) {
  const palette = useFormPalette();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Typography
        component="label"
        sx={{
          fontSize: NODE_UI.fontSize.label,
          fontWeight: NODE_UI.fontWeight.label,
          color: palette.textSecondary,
          lineHeight: 1.4,
          userSelect: 'none',
        }}
      >
        Stepper label
      </Typography>
      <InputBase
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Short label shown in the stepper (falls back to the step title)"
        fullWidth
        sx={{
          fontFamily: 'inherit',
          fontSize: NODE_UI.fontSize.value,
          color: palette.textPrimary,
          border: `1px solid ${palette.border}`,
          borderRadius: NODE_UI.borderRadiusSm,
          px: '8px',
          py: '5px',
          '&:hover': { borderColor: palette.textSecondary },
          '&.Mui-focused': { borderColor: palette.textPrimary },
          '& input::placeholder': { color: palette.textSecondary, opacity: 0.5 },
        }}
      />
    </Box>
  );
}
